import React from 'react';
import {
  ChatThreadPlaceHolderBox,
  ChatThreadBgBox,
  ChatThreadPlaceHolderContainer,
  ChatThreadPlaceHolderColumn,
  ChatThreadPlaceHolderColumnTitle,
  ChatThreadPlaceHolderQuestionItem,
  ChatThreadPlaceHolderIconContainer,
  ChatThreadPlaceHolderTitle,
  ChatThreadPlaceHolderSubTitle,
} from './styled';
import { useAtomValue } from 'jotai';
import { questionsInWelcomePageAtom } from '../atoms';
import useHandleUserMessage from '../hooks/useHandleUserMessage';
import { CATEGORY_ICON_MAP } from '../utils';

function ChatThreadBgPlaceholder({ getStream }) {
  const questionList = useAtomValue(questionsInWelcomePageAtom);
  const { submitQuestion } = useHandleUserMessage({ getStream });

  const handleQuestionClick = (question) => {
    submitQuestion(question);
  };

  return (
    <ChatThreadPlaceHolderBox>
      <ChatThreadPlaceHolderTitle>Welcome to PromptAI</ChatThreadPlaceHolderTitle>
      <ChatThreadPlaceHolderSubTitle>What do you want to know today?</ChatThreadPlaceHolderSubTitle>
      <ChatThreadBgBox>
        <ChatThreadPlaceHolderContainer>
          {questionList.map((category) => {
            const Icon = CATEGORY_ICON_MAP[category.title];
            return (
              <ChatThreadPlaceHolderColumn key={category.title}>
                <ChatThreadPlaceHolderIconContainer>
                  <Icon />
                </ChatThreadPlaceHolderIconContainer>
                <ChatThreadPlaceHolderColumnTitle
                  style={{ color: category.title === 'Analysis' ? '#4d7eff' : '#4c4c4c' }}
                >
                  {category.title}
                </ChatThreadPlaceHolderColumnTitle>
                {category.questions.map((question) => {
                  return (
                    <ChatThreadPlaceHolderQuestionItem
                      key={question}
                      onClick={() => {
                        handleQuestionClick(question);
                      }}
                    >
                      {question}
                    </ChatThreadPlaceHolderQuestionItem>
                  );
                })}
              </ChatThreadPlaceHolderColumn>
            );
          })}
        </ChatThreadPlaceHolderContainer>
      </ChatThreadBgBox>
    </ChatThreadPlaceHolderBox>
  );
}

export default ChatThreadBgPlaceholder;
